@if (approval) {
  <div class="d-flex justify-content-end align-items-center gap-3 mt-3">
    @if (isApproved) {
      <span class="text-muted small fst-italic">
        Approved by {{ approval.approvedByByline }}
        {{ approval.approvedAt | date:'MM/dd/yyyy' }}
      </span>
      <button type="button" class="btn btn-secondary" disabled>Approve</button>
    } @else {
      <button type="button" class="btn btn-success" (click)="onApproveClick()">Approve</button>
    }
  </div>
}
